import { useEffect, useState } from "react";

const rtf = new Intl.RelativeTimeFormat(undefined, { numeric: "auto" });

export function relativeTime(iso: string | null | undefined, now = Date.now()): string {
  if (!iso) return "";
  const t = Date.parse(iso);
  if (Number.isNaN(t)) return iso;
  const diff = (t - now) / 1000;
  const abs = Math.abs(diff);
  if (abs < 45) return "just now";
  if (abs < 3600) return rtf.format(Math.round(diff / 60), "minute");
  if (abs < 86400) return rtf.format(Math.round(diff / 3600), "hour");
  if (abs < 86400 * 7) return rtf.format(Math.round(diff / 86400), "day");
  const d = new Date(t);
  const sameYear = d.getFullYear() === new Date(now).getFullYear();
  return d.toLocaleDateString(undefined, {
    month: "short",
    day: "numeric",
    ...(sameYear ? {} : { year: "numeric" }),
  });
}

export function fullDate(iso: string | null | undefined): string {
  if (!iso) return "";
  const t = Date.parse(iso);
  return Number.isNaN(t) ? iso : new Date(t).toLocaleString();
}

let tickListeners = new Set<() => void>();
let tickTimer: number | undefined;

/** Re-render every 30 s so relative times stay fresh. */
export function useNowTick(): number {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const fn = () => setNow(Date.now());
    tickListeners.add(fn);
    if (tickTimer === undefined) {
      tickTimer = window.setInterval(() => tickListeners.forEach((l) => l()), 30_000);
    }
    return () => {
      tickListeners.delete(fn);
      if (tickListeners.size === 0 && tickTimer !== undefined) {
        window.clearInterval(tickTimer);
        tickTimer = undefined;
        tickListeners = new Set();
      }
    };
  }, []);
  return now;
}
